import React from "react";
import styles from "./styles.module.css";
import { useContext, useState } from "react";
import { BlocksValue } from "../../../contexts/blocks";
import { AppValue } from "../../../contexts/app";
import Card from "./card";
import CompCard from "./compcard";

export default function Results({ search, pageId }) {
  const blocks = useContext(BlocksValue);
  const { components } = useContext(AppValue);
  return (
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
      {blocks
        .filter((x) => x.type !== "page" && x.type !== "_component")
        .filter((x) => {
          return x.name.includes(search);
        })
        .map((b) => {
          return (
            <Card
              block={b}
              type={b.type === "overlay" ? "overlay" : null}
              key={b.name}
            />
          );
        })}
      {components
        .filter((x) => x.name !== pageId)
        .filter((x) => {
          return x.name.includes(search);
        })
        .map((b) => {
          return <CompCard key={b.name} comp={b} />;
        })}
    </div>
  );
}
